import toastMessage from "../toastMessage";
import { getStorage } from "../storage";
import api from "../api";

const API_URL = process.env.REACT_APP_BBMS_BASE_API;

const fetchBloodCollectionPlan = async (lng = "english", params = {}) => {
  try {
    const user = await getStorage();
    const res = await api({
      method: "GET",
      url: `${API_URL}/bloodCollectionPlan`,
      params,
      headers: { Authorization: `Bearer ${user.token}` },
    });
    return res.data;
  } catch (error) {
    toastMessage("error", "Unable to fetch collection plan");
  }
};

export const createBloodCollectionPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "POST",
    url: `${API_URL}/bloodCollectionPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const updateBloodCollectionPlan = async (lng = "english", body) => {
  const user = await getStorage();
  return api({
    method: "PUT",
    url: `${API_URL}/bloodCollectionPlan`,
    data: body,
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export const deleteBloodCollectionPlan = async (lng = "english", id) => {
  const user = await getStorage();
  return api({
    method: "DELETE",
    url: `${API_URL}/bloodCollectionPlan`,
    data: { id },
    headers: { Authorization: `Bearer ${user.token}` },
  });
};

export default fetchBloodCollectionPlan;
